module.exports = __webpack_public_path__ + "assets/manual_boxVHI-b57f6a0e45858857a41b37714d7579f2.pdf";